import { Log } from '@/shared/Log';

export const useLogger = () => {
    const currentPage =
        typeof window !== 'undefined' && window.location
            ? window.location.pathname
            : '';

    return (message: string, additionalData?: unknown) => {
        const context = currentPage
            ? `[Page: ${currentPage}]`
            : '[No Page Context]';

        if (additionalData) {
            Log.info(`CaregiverSpace: ${context} ${message}`, additionalData);
        } else {
            Log.info(`CaregiverSpace: ${context} ${message}`);
        }
    };
};
